import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Crusader Strike",
    "spell_holy_crusaderstrike",
    [
      "An instant strike that causes 75% weapon damage as Holy and regenerates 5% of your maximum mana. The duration of all Judgement effects on the target is refreshed to 30 sec.",
    ],
    1,
    [[]],
    null,
    null,
    "Instant",
    "6 sec cooldown",
    null,
    null,
    null,
    { isMoved: false, isChanged: false, isNew: true },
  ),
  null,
  null,
];

export default tier7;
